export default __webpack_public_path__ + "static/media/EFUL.a75f32ca.png";